import { Link } from 'react-router-dom'

import {
  Main,
} from 'components'

import {
  Heading,
  Message,
} from './notFoundStyle'

const NotFound = () => (
  <Main>
    <Heading>Page not found</Heading>

    <Message>We couldn't find anything here. Try <Link to={-1}>going back</Link>.</Message>
  </Main>
)

export default NotFound